/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Business_WebsiteInputs */

const en_label_business_website = /** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Website`)
};

const es_label_business_website = /** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio Web del Negocio`)
};

const fr_label_business_website = /** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site web de l'entreprise`)
};

const de_label_business_website = /** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmens-Website`)
};

const id_label_business_website = /** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs Web Bisnis`)
};

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const ja_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const zh_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const ar_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const it_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const ru_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const pt_label_business_website = en_label_business_website;

/** @type {(inputs: Label_Business_WebsiteInputs) => LocalizedString} */
const ko_label_business_website = en_label_business_website;

/**
* | output |
* | --- |
* | "Business Website" |
*
* @param {Label_Business_WebsiteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_business_website = /** @type {((inputs?: Label_Business_WebsiteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Business_WebsiteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_business_website(inputs)
	if (locale === "es") return es_label_business_website(inputs)
	if (locale === "fr") return fr_label_business_website(inputs)
	if (locale === "de") return de_label_business_website(inputs)
	if (locale === "ja") return ja_label_business_website(inputs)
	if (locale === "zh") return zh_label_business_website(inputs)
	if (locale === "ar") return ar_label_business_website(inputs)
	if (locale === "id") return id_label_business_website(inputs)
	if (locale === "it") return it_label_business_website(inputs)
	if (locale === "ru") return ru_label_business_website(inputs)
	if (locale === "pt") return pt_label_business_website(inputs)
	return ko_label_business_website(inputs)
});